<template>
	<div :class="dynamicclass" class="hotpspot" @click="handleClick(index)">
		<div class="circle" style="animation-delay: -1s"></div>
		<div class="y-circle" style="animation-delay: 0s"></div>
	</div>
</template>

<script>
import {useRouter} from "vue-router";
import Cookie from 'vue-cookie'
import {inject} from "vue";

export default {
  name: "HotSpot",
	data() {
		return {
			showStagger: false
		}
	},
  props: {
    hotspot: {type: String},
    index: {type: Number},
		dynamicclass: {type: String}
  },
  setup() {
    const router = useRouter()
    const store = inject("store");

    const handleClick = (page) => {
      store.actions.setHotspotState(true);
      switch (page) {
        case 1:
          router.push(getTo("/video"));
          break;
        case 2:
          router.push(getTo("/music"));
          break;
        case 3:
          router.push(getTo("/audio-adventure"));
          break;
        case 4:
          router.push(getTo("/grow-with-me"));
          break;
        case 5:
          router.push(getTo("/safety-element"));
          break;
        default:
          break;
      }
    }
    function getTo(localizedRoute) {
			const locale = Cookie.get('locale');
      // we strip leading and trailing slashes and prefix
      // the current locale
      return `/${locale}/${localizedRoute.replace(/^\/|\/$/g, "")}`
    }
    return {
      handleClick
    }
  },
	mounted() {
		this.$nextTick(() => {
			this.showStagger = true;
		});
	},
}
</script>

<style scoped>
  .hotspot4 {
    top: 15em;
    left: 5em;
  }
  .hotspot5 {
    top: 24.5em;
    left: 11em;
  }
  .hotspot3 {
    top: 12.5em;
    left: 16em;
  }
  .hotspot2 {
    top: 11.6em;
    left: 20.5em;
  }
  .hotspot1 {
    top: 8em;
    right: 1.5em;
  }
 .hotpspot {
  position: absolute;
  cursor: pointer;
	width: 20px;
	height: 20px;
}
/*.hotspot4 {
  top: 13em;
  left: 4em;
}
.hotspot5 {
  top: 21em;
  left: 9.3em;
}
.hotspot3 {
  top: 11em;
  left: 14em;
}
.hotspot2 {
  top: 9.8em;
  left: 17.5em;
}
.hotspot1 {
  top: 8em;
  right: 2.7em;
} */
.hotspot1.small .y-circle, .hotspot1.small .circle {
  width: 15px;
  height: 15px;
}
.y-circle {
  background-color: #ffe400;
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  position: absolute;
}
.circle {
  border-radius: 50%;
  background-color: transparent;
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  border: 1px solid #fff;
  animation: scaleIn 2s infinite ease-in-out;
}
@keyframes scaleIn {
  0% {
    transform: scale(1, 1);
    opacity: 0;
  }
  50% {
    transform: scale(1.5, 1.5);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}

@media (max-width: 414px) {
  /* .hotspot4 {
    top: 15em;
    left: 5em;
  }
  .hotspot5 {
    top: 24.5em;
    left: 11em;
  }
  .hotspot3 {
    top: 12.5em;
    left: 16em;
  }
  .hotspot2 {
    top: 11.6em;
    left: 20.5em;
  }
  .hotspot1 {
    top: 9em;
    right: 3em;
  } */
}
</style>
